const API_URL = process.env.REACT_APP_API_URL;

/**
 * Converts speech to text using OpenAI's API
 * @param {Blob} audioBlob - The audio blob to convert
 * @param {Function} onProgress - Optional callback for progress updates
 * @returns {Promise<string>} The transcribed text
 */
export const convertSpeechToText = async (audioBlob, onProgress) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        formData.append('file', audioBlob, 'recording.webm');

        xhr.upload.addEventListener('progress', event => {
            if (event.lengthComputable && onProgress) {
                const percentCompleted = Math.round((event.loaded * 100) / event.total);
                const progress = percentCompleted > 90 ? 90 : percentCompleted;
                onProgress(progress);
            }
        });

        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    onProgress?.(100);
                    const response = JSON.parse(xhr.responseText);
                    resolve(response.text);
                } catch (error) {
                    reject(new Error('Invalid JSON response'));
                }
            } else {
                try {
                    const errorResponse = JSON.parse(xhr.responseText);
                    reject(new Error(errorResponse.error || 'Transcription failed'));
                } catch (error) {
                    reject(new Error('Transcription failed'));
                }
            }
        });

        xhr.addEventListener('error', () => {
            reject(new Error('Transcription failed'));
        });

        xhr.open('POST', `${API_URL}/api/speech/transcribe`, true);
        xhr.withCredentials = true;
        xhr.send(formData);
    });
};
